import Container from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import { StyledContainer } from "@components/Styled/Container";
import { css } from "@emotion/react";
import React, { Suspense, lazy } from "react";
import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw, { styled } from "twin.macro";
import { withImageCarousel } from "./withImageCarousel";

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "@components/Swiper/Swiper"),
);
SwiperCore.use([Pagination]);

const Wrapper = styled(StyledContainer)`
  ${tw`relative`}
  ${css`
    > .swiper-container {
      position: initial;
    }
  `}
`;

const ImageCarousel = withImageCarousel(({ images, onClickImage, styles }) => (
  <Container
    className="bg-neutral pb-giga"
    styles={styles}
    data-component-type="section-image-carousel"
  >
    <Wrapper width="full">
      <Suspense fallback={<></>}>
        <Swiper
          slidesPerView={2.2}
          lazy={true}
          preloadImages={false}
          pagination={{ clickable: true }}
          observer={true}
          observeParents={true}
          breakpoints={{
            320: {
              slidesPerView: 2.2,
              observer: true,
              observeParents: true,
            },
          }}
        >
          {images?.map((image, index) => {
            return (
              <SwiperSlide key={index} data-testid="image-carousel-swiper">
                <Image
                  image={image}
                  alt={image?.alt}
                  ratio="4/5"
                  onClick={onClickImage}
                  imageLink={image?.imageLink}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Suspense>
    </Wrapper>
  </Container>
));

export default ImageCarousel;
